import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Mike R.',
  role: 'Racing Team Owner',
  content: "The DTF transfers for our pit crew shirts were incredible. Super vibrant colors and they've held up through the whole season. Fast shipping too!",
  rating: 5
}, {
  name: 'Sarah T.',
  role: 'Small Business Owner',
  content: "I've used several print shops before, but Atomic is by far the easiest to work with. No minimums meant I could test a few designs before committing to a larger order.",
  rating: 5
}, {
  name: 'Jason K.',
  role: 'Event Organizer',
  content: 'Needed 50 shirts for a last-minute charity 5K. They turned it around in days and the print quality was perfect. Highly recommend for local events.',
  rating: 5
}, {
  name: 'Amanda L.',
  role: 'School Booster Club',
  content: 'Great communication throughout the whole process. The digital proofs made it easy to approve, and the final spirit wear looks amazing.',
  rating: 5
}, {
  name: 'Chris P.',
  role: 'Contractor',
  content: 'Our work hoodies take a beating on the job site. The screen printing from Atomic has lasted longer than the shirts themselves. Solid quality.',
  rating: 5
}];
export function Testimonials() {
  return <section className="relative py-24 border-t border-white/5 overflow-hidden" data-id="element-400">
      {/* Background image */}
      <div className="absolute inset-0 z-0" data-id="element-401">
        <img src="https://cdn.magicpatterns.com/uploads/dYC5uZkL8LyzcKf6wyDc11/Trusted_by_Teams_and_Businesses-bg.jpg" alt="Williams Farms team wearing custom printed hoodies on the job" className="absolute inset-0 w-full h-full object-cover" data-id="element-402" />
      </div>
      <div className="absolute inset-0 z-0 bg-atomic-black/60" data-id="element-403" />
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-atomic-black/68 via-atomic-black/53 to-atomic-black/68" data-id="element-404" />

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-405">
        <div className="text-center mb-16" data-id="element-406">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-407">
            Trusted by Teams & Businesses
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg" data-id="element-408">
            See why customers across Michigan and the US choose Print Atomic for
            their custom apparel and printing needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto" data-id="element-409">
          {testimonials.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-atomic-charcoal p-8 rounded-xl border border-white/10 hover:border-atomic-green/30 transition-colors" data-id="element-410">
              <div className="flex gap-1 mb-4" data-id="element-411">
                {[...Array(review.rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-atomic-green text-atomic-green" data-id="element-412" />)}
              </div>
              <p className="text-gray-300 mb-6 leading-relaxed" data-id="element-413">
                "{review.content}"
              </p>
              <div data-id="element-414">
                <p className="text-white font-bold" data-id="element-415">{review.name}</p>
                <p className="text-atomic-green text-sm" data-id="element-416">{review.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}